import {Routes} from '@angular/router';
import {ConversationsComponent} from '@pages/conversations/conversations.component';

export const CONVERSATIONS_ROUTES: Routes = [
  {
    path: '',
    component: ConversationsComponent,
    data: {
      title: 'Conversazioni',
      titleKey: 'menu.conversations',
    }
  }
];
